import React, { useEffect, useRef, useState } from 'react'

import { Divider, Input, Modal, Typography } from 'antd'
import RichTextEditor from '../base/RichTextEditor'
import { convertToHTML } from 'draft-convert'
import {URL_WRITER_STATEMENT} from "../../const";

const { Title, Text } = Typography

const { TextArea } = Input

const StoryEditForm = ({ toLoad, toLoadTitle, visible, onSubmit, onCancel }) => {
  //destructures props
  const inputRef = useRef()
  const titleRef = useRef()
  const [title, setTitle] = useState(toLoadTitle)
  useEffect(() => {
    if (toLoad && inputRef.current && visible) {
      inputRef.current.loadCurr()
    }
    setTitle(toLoadTitle)
  }, [toLoad, visible, toLoadTitle])

  return (
    <Modal
      visible={visible}
      title='Edit Art Statement'
      okText='OK'
      onCancel={onCancel}
      width={'66vw'}
      style={{ top: 20 }}
      onOk={() => {
        const editor = inputRef.current?.state.editorState
        if (editor && editor.getCurrentContent().hasText()) {
          const html = convertToHTML(editor.getCurrentContent())
          if (onSubmit) onSubmit(title, html)
        }
      }}
    >
      <div
        style={{
          width: '100%',
          height: '66vh',
          paddingTop: 6,
          paddingBottom: 6,
          paddingRight: 24,
          overflowY: 'auto',
          overflowX: 'hidden'
        }}
      >
        <i>
          Tell the audiences about your art's inspiration, purpose, unique process, and story behind the works.{' '}
          <a style={{ color: 'black', textDecoration: 'underline' }} href={'https://revart.co/sam/faq/docs/doc-showcase/'}>
            Learn More
          </a>
          .
        </i>
        <Divider />
        <h5>Statement:</h5>
        <Input
          defaultValue={title}
          value={title}
          addonBefore='Title'
          onChange={(e) => {
            setTitle(e.target.value)
          }}
          ref={titleRef}
        />
        <RichTextEditor style={{ minHeight: 260 }} ref={inputRef} toLoad={toLoad} />
      </div>
    </Modal>
  )
}

export default StoryEditForm
